<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="hierarchyForm">
      <div class="">
        <h3 class="form_name">Hierarchy</h3>


        <div class="input">
          <label for="">Hierarchy</label>
          <input type="text" class="default_input reference-form" formControlName="HierarchyName" />
        </div>

        <div class="input">
          <label for="">Abbreviation</label>
          <input type="text" class="default_input reference-form" formControlName="Abbreviation" />
        </div>

        <div class="input">
          <label for="">Description</label>
          <input type="text" class="default_input reference-form" formControlName="Description" />
        </div>


        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(hierarchyForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(hierarchyForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search" placeholder="Search for Hierarchy" [formControl]="control"
          [appAutocomplete]="autocomplete" />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container *ngIf="(hierarchys | filterReference: control.value) as result">
              <app-option (click)="selectHierarchy(option.id)" *ngFor="let option of result" [value]="option.HierarchyName">
                {{ option.HierarchyName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length">No result...</app-option>
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head">
        <span class="item">S/N</span>
        <span class="item">Hierarchy Name</span>
        <span class="item">Abbreviation</span>
        <span class="item">Description</span>
        <span class="item">Action</span>

      </div>

      <div class="scroll">

      </div>
      <div class="body_content">
        <div class="the_body" *ngFor="let hierarchy of hierarchyFormArray.get('Hierarchys')['controls']; index as i"
          (click)="onEdit(i, hierarchy.value)" style="cursor: pointer;" matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over">
          <span class="content">{{i + 1}}</span>
          <span class="content">{{hierarchy.value.HierarchyName}}</span>
          <span class="content">{{hierarchy.value.Description}}</span>
          <span class="content">{{hierarchy.value.Abbreviation}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button class="delete_icon trash" (click)="deleteHierarchy(i, hierarchy.value)">
              <em class="ti-trash"> </em> </button>
          </span>

        </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(hierarchyFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
